import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Toggle = styled.button`
  width: 100%;
  padding-right: 44px;
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 50px 0 12px;
  box-sizing: border-box;
  background-color: ${({ bgColor }) => bgColor};
  outline-color: ${({ oColor }) => oColor};
  border: 1px solid ${({ bColor }) => bColor};
  border-radius: 4px;

  span {
    font-size: 14px;
  }
`;

export const ClearButton = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 14px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ color }) => color};
`;

export const Dropdown = styled.div`
  position: absolute;
  z-index: 9;
  top: 42px;
  right: 0;
  min-width: 115px;
  padding: 24px;
  border: 1px solid ${({ bColor }) => bColor};
  border-radius: 4px;
  background-color: ${({ bgColor }) => bgColor};
  box-shadow: 0 0 6px 2px rgb(0 0 0 / 6%);
`;
